export interface IUserType {
  name: string;
  value: string;
}

export const userTypes: IUserType[] = [
  { name: 'PO Manager', value: 'POManager' },
  { name: 'Invoice Manager', value: 'InvoiceManager' },
  { name: 'Contracts Manager', value: 'ContractsManager' },
  { name: 'User Manager', value: 'UserManager' },
  { name: 'Punch List Manager', value: 'PunchlistManager' },
  { name: 'Compaction Manager', value: 'CompactionManager' }
];

export const userTypesHashTable = userTypes.reduce(
  (obj, item) => Object.assign(obj, { [item.value]: item.name }),
  {}
);

export enum ExternalUserRoles {
  Attorney = 'Attorney',
  Custom = 'Custom',
  Employee = 'Employee',
  InternalAgent = 'InternalAgent',
  // Lender and LenderProcessor should have the same role permissions
  Lender = 'Lender',
  LenderProcessor = 'LenderProcessor',
  Purchaser = 'Purchaser',
  Supplier = 'Supplier',
  VendorAffiliate = 'VendorAffiliate'
}

export enum InternalJobTitles {
  AccountingAssistant = 'AccountingAssistant',
  AssistantController = 'AssistantController',
  BillingAdmin = 'BillingAdmin',
  CEO = 'CEO',
  CLO = 'CLO',
  ContentManager = 'ContentManager',
  Controller = 'Controller',
  DirectorOfArchitecture = 'DirectorOfArchitecture',
  DirectorOfLandManagement = 'DirectorOfLandManagement',
  DirectorOfMarketing = 'DirectorOfMarketing',
  DivisionPresidentNorth = 'DivisionPresidentNorth',
  DivisionPresidentSouth = 'DivisionPresidentSouth',
  Draftsman = 'Draftsman',
  Estimator = 'Estimator',
  FacilitiesMaintenance = 'FacilitiesMaintenance',
  FieldAssistant = 'FieldAssistant',
  FinancialAdmin = 'FinancialAdmin',
  ForemanNorth = 'ForemanNorth',
  ForemanSouth = 'ForemanSouth',
  GlobalAdmin = 'GlobalAdmin',
  GraphicDesigner = 'GraphicDesigner',
  IT = 'IT',
  MarketManager = 'MarketManager',
  PayrollManager = 'PayrollManager',
  PermitSpecialist = 'PermitSpecialist',
  ProjectManagerNorth = 'ProjectManagerNorth',
  ProjectManagerSouth = 'ProjectManagerSouth',
  ProjectManagerTnd = 'ProjectManagerTnd',
  Receptionist = 'Receptionist',
  SalesAdmin = 'SalesAdmin',
  SalesAssistant = 'SalesAssistant',
  SalesCounselor = 'SalesCounselor',
  Shareholder = 'Shareholder',
  SuperintendentNorth = 'SuperintendentNorth',
  SuperintendentSouth = 'SuperintendentSouth',
  SuperintendentTnd = 'SuperintendentTnd',
  WarrantySuperintendent = 'WarrantySuperintendent',
  WarrantyAdmin = 'WarrantyAdmin'
}
